import { useContractFunction } from "@usedapp/core";
import { utils } from "ethers";
import { Contract } from "@ethersproject/contracts";
import AirdropDistributor from "@/chain-info/contracts/AirdropDistributor.json";

export const useStopTokenAirdrop = (tokenAddress: string) => {
  const { abi } = AirdropDistributor;
  const airdropFactoryInterface = new utils.Interface(abi);
  const airdropFactoryContract = new Contract(
    tokenAddress,
    airdropFactoryInterface
  );
  const { send: stopSend, state: stopTokenAirdropState } = useContractFunction(
    airdropFactoryContract as any,
    "stopCampaign",
    {
      transactionName: "Stop Campaign",
    }
  );
  const stopTokenAirdrop = () => {
    return stopSend();
  };
  return {
    stopTokenAirdrop,
    stopTokenAirdropState,
  };
};
